export default __webpack_public_path__ + "static/media/logout-red.cfd5ec4f.svg";